import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'localDate',
  standalone:true
})
export class LocalDatePipe implements PipeTransform {
  constructor() {
  }

  transform(value: Date, args?: any): string {
    return this.GetClientDateOnly(value);
  }

  GetClientDateOnly(dateTime: Date): string {
    let parsedDate = "";
    if (dateTime !== undefined && dateTime != null) {
      let dated: Date = new Date(dateTime);
      let date = dated.getDate();
      let year = dated.getFullYear();
      let month = dated.getMonth() + 1;
      parsedDate = `${date < 10 ? '0' : ''}${date}/${month < 10 ? '0' : ''}${month}/${year}`;
    }
    return parsedDate;
  }
}